/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AuditScopeType = {
    Conversation: 'CONVERSATION',
    User: 'USER',
    Webhook: 'WEBHOOK',
    Task: 'TASK',
    Sms: 'SMS',
    Email: 'EMAIL',
    Geocoding: 'GEOCODING'
} as const;
export type AuditScopeType = typeof AuditScopeType[keyof typeof AuditScopeType];


export function instanceOfAuditScopeType(value: any): boolean {
    for (const key in AuditScopeType) {
        if (Object.prototype.hasOwnProperty.call(AuditScopeType, key)) {
            if (AuditScopeType[key as keyof typeof AuditScopeType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AuditScopeTypeFromJSON(json: any): AuditScopeType {
    return AuditScopeTypeFromJSONTyped(json, false);
}

export function AuditScopeTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditScopeType {
    return json as AuditScopeType;
}

export function AuditScopeTypeToJSON(value?: AuditScopeType | null): any {
    return value as any;
}

export function AuditScopeTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AuditScopeType {
    return value as AuditScopeType;
}

